module.exports = __webpack_public_path__ + "img/next1.95ac9eb9.svg";